import React from 'react';

import EditRecipeBodyLoadedStep from './loaded/EditRecipeBodyLoadedStep';
import EditRecipeBodyLoadingStep from './loading/EditRecipeBodyLoadingStep';

import useEditRecipeBodyStep from './useEditRecipeBodyStep';

const EditRecipeBodyStep = ({
  id,
  step,
  pageTitle,
  router,
  exitPage,
  goToMenuPage,
}) => {
  const {
    Read,
    onRecipeSaved,
    recipeContent,
    userOwnsRecipe,
  } = useEditRecipeBodyStep(id);

  const { hasLoaded } = Read;

  if (!hasLoaded)
    return (
      <EditRecipeBodyLoadingStep
        Read={Read}
        exitPage={exitPage}
        pageTitle={pageTitle}
      ></EditRecipeBodyLoadingStep>
    );

  return (
    <EditRecipeBodyLoadedStep
      id={id}
      step={step}
      pageTitle={pageTitle}
      router={router}
      userOwnsRecipe={userOwnsRecipe}
      exitPage={exitPage}
      goToMenuPage={goToMenuPage}
      onRecipeSaved={onRecipeSaved}
      recipeContent={recipeContent}
    ></EditRecipeBodyLoadedStep>
  );
};

export default EditRecipeBodyStep;
